import { useApiQuery } from '../useApiQuery';
import { apiGet, operationsClient } from '@/lib/api';
import { estimateDocTemplateEndpoints } from '@/lib/api/endpoints';
import { estimateDocTemplateKeys } from '@/lib/queryKeys';
import type { EstimateDocTemplateSummary, EstimateDocType } from '@/types/estimateDocTemplate';

export interface DocTemplateListParams {
  docType?: EstimateDocType;
  status?: 'DRAFT' | 'PUBLISHED';
}

/** Lists the tenant's estimate document templates (summaries, no layout). */
export function useEstimateDocTemplates(params: DocTemplateListParams = {}) {
  const qs = new URLSearchParams();
  if (params.docType) qs.set('docType', params.docType);
  if (params.status) qs.set('status', params.status);
  const suffix = qs.toString() ? `?${qs.toString()}` : '';
  return useApiQuery<EstimateDocTemplateSummary[]>({
    queryKey: estimateDocTemplateKeys.list(params),
    queryFn: () =>
      apiGet<EstimateDocTemplateSummary[]>(
        operationsClient,
        `${estimateDocTemplateEndpoints.list()}${suffix}`,
      ),
  });
}
